import React from "react";
import { NavLink, Link } from "react-router-dom";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "overlayscrollbars/css/OverlayScrollbars.css";
import { Helmet } from "react-helmet";
import metatags from "./metatags";
class Faq extends React.Component {
  constructor(props) {
    super(props);
    this.acc1 = React.createRef();
    this.acc2 = React.createRef();
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.props.faq_JsonData();
  };

  accordionClick = (event, getFold) => {
    if (getFold == "acc1") {
      setTimeout(() => {
        window.scrollTo(0, this.acc1.current.offsetTop);
      }, 200);
    } else if (getFold == "acc2") {
      setTimeout(() => {
        window.scrollTo(0, this.acc2.current.offsetTop);
      }, 200);
    }
  };

  faq_closeBtn = () => {
    window.location.href = "/";
  };

  render() {
    return (
      <section className="cmx-tc-page">
        <Helmet>
          <title>{metatags.faqMetatag.title}</title>
          <meta name="description" content={metatags.faqMetatag.description} />
        </Helmet>
        <section className="tc-container">
          <aside className="close-icon">
            <a onClick={this.faq_closeBtn} title="Close" href="javascript:;">
              <span>&nbsp;</span>
            </a>
          </aside>
          <aside className="head text-center pt-4 pb-4">
            <h1>
              <span className="txt-top d-block">Frequently Asked Questions</span>
            </h1>
          </aside>
          <section class="plandetailsnew">
            <section className="faq-wrapper">
              <OverlayScrollbarsComponent
                options={{
                  paddingAbsolute: true,
                  autoUpdate: true,
                  scrollbars: {
                    clickScrolling: true,
                    visibility: "auto",
                  },
                  overflowBehavior: {
                    x: "scroll",
                    y: "hidden",
                  },
                }}
                className="mcsbWrapper"
                id="categoryOverlayScrollbar"
              >
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="movieflex-tab" data-bs-toggle="tab" data-bs-target="#movieflex" type="button" role="tab" aria-controls="movieflex" aria-selected="true">
                      Passport by CMX
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="movieflexplus-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#movieflexplus"
                      type="button"
                      role="tab"
                      aria-controls="movieflexplus"
                      aria-selected="true"
                    >
                      Signing Up
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="signin-tab" data-bs-toggle="tab" data-bs-target="#signin" type="button" role="tab" aria-controls="signin" aria-selected="false">
                      Food and Drink Discounts
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="purchase-redeem-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#purchaseredeem"
                      type="button"
                      role="tab"
                      aria-controls="purchaseredeem"
                      aria-selected="false"
                    >
                      Billing
                    </button>
                  </li>
                </ul>
              </OverlayScrollbarsComponent>
              <div className="tab-content" id="myTabContent">
                <section className="tab-pane fade show active" id="movieflex" role="tabpanel" aria-labelledby="movieflex-tab">
                  <div className="accordion" id="movieflex-accordionParent">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-1">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-1"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-1"
                        >
                          What is CMX Passport?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-1" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-1" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>
                              Passport by CMX is a customizable membership program available at all CMX Cinemas in the U.S. A user can choose how many movies per month, how many guests they bring with
                              them, and if they would like to pay monthly or annually.
                            </p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-2">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-2"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-2"
                        >
                          What is the difference between CMX Rewards and CMX Passport?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-2" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-2" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>CMX Rewards is a free rewards and loyalty program. CMX Passport is a paid movie membership service.</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-3">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-3"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-3"
                        >
                          Do I need to be a CMX Rewards Member before joining CMX Passport?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-3" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-3" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>Yes, a guest must have a CMX Rewards account before joining the CMX Passport membership program. A new user can sign up for both programs at the same time.</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item" ref={this.myRef1}>
                      <h2 className="accordion-header" id="movieflex-heading-4">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-4"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-4"
                        >
                          Is there a physical card associated with the CMX Passport program?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-4" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-4" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>
                              No, we do not offer physical cards. A guest will use the CMX Mobile App to access their membership program. There is a Digital Membership card available in the CMX Mobile
                              App.
                            </p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-5">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-5"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-5"
                        >
                          Do I have to use the mobile app to use CMX Passport?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-5" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-5" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>
                              Yes, you must use the mobile app to redeem your credits in CMX Passport. Guests can sign up on the website, but they will need the CMX Mobile App to reserve their CMX
                              Passport membership tickets in the CMX Mobile App.
                            </p>
                            <p>The CMX Mobile App is free to download. </p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-6">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-6"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-6"
                        >
                          When will my CMX Passport Membership begin?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-6" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-6" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>The Passport program begins immediately after payment is received. Sign up today and enjoy the benefits today.</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-7">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-7"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-7"
                        >
                          What are the benefits of the Passport?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-7" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-7" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <aside className="list">
                              <ul>
                                <li>
                                  <p>Earn Rewards for using your Passport</p>
                                </li>
                                <li>
                                  <p>10% off Food and Beverage purchases (excluding alcoholic beverages)</p>
                                </li>
                                <li>
                                  <p>Pay monthly and get upgraded to Platinum in CMX Rewards</p>
                                </li>
                                <li>
                                  <p>Pay annually and get upgraded to Diamond in CMX Rewards</p>
                                </li>
                                <li>
                                  <p>Invites to early screenings plus other special offers</p>
                                </li>
                              </ul>
                            </aside>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-8">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-8"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-8"
                        >
                          How do I use my Passport credits to buy a ticket?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-8" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-8" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>Passport credits and all benefits are managed exclusively on the CMX Mobile App.</p>
                            <p>
                              To use your credits, access your theatre, film, and showtime on the CMX Mobile App. Your Passport credits are made available as you select your seat. Credits are
                              redeemable only at locations a part of your purchased program.
                            </p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-9">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-9"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-9"
                        >
                          Is there a limit to the number of credits used in a ticket transaction?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-9" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-9" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>A member can use one member credit per transaction and any amount of guest credits in their account.</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-10">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-10"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-10"
                        >
                          What happens if I do not use my Passport credit during the month?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-10" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-10" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>All credits rollover for one year from the date issued. At the end of the year, your credits will not be available.</p>
                            <p>If you decide to cancel or not renew your membership, you will lose all credits once your membership stops at the end of your billing cycle.</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-11">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-11"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-11"
                        >
                          Can I share my credits with another member?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-11" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-11" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>No. Credits cannot be transferred to another member.</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-12">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-12"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-12"
                        >
                          Do I have to use my Passport credit for a movie ticket?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-12" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-12" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>No. Users have the option to buy full-priced tickets, Rewards, along with using their Passport credits.</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-heading-13">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-collapse-13"
                          aria-expanded="false"
                          aria-controls="movieflex-collapse-13"
                        >
                          Are there any additional charges or fees for using Passport?
                        </button>
                      </h2>
                      <div id="movieflex-collapse-13" className="accordion-collapse collapse" aria-labelledby="movieflex-heading-13" data-bs-parent="#movieflex-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>We do have an upgrade fee for IMAX and DBOX films.</p>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="tab-pane fade" id="movieflexplus" role="tabpanel" aria-labelledby="movieflexplus-tab">
                  <div className="accordion" id="movieflexplus-accordionParent">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-plus-heading-1">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-plus-collapse-1"
                          aria-expanded="false"
                          aria-controls="movieflex-plus-collapse-1"
                        >
                          How do I sign up for the Passport?
                        </button>
                      </h2>
                      <div id="movieflex-plus-collapse-1" className="accordion-collapse collapse" aria-labelledby="movieflex-plus-heading-1" data-bs-parent="#movieflexplus-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>
                              Download the CMX Mobile App and choose Passport in the bottom toolbar. Follow the prompts to sign up for the program. Once you have finished checking out, your program
                              will be available for use in the CMX Mobile App.
                            </p>
                            <p>You can also purchase a membership through passport.cmxcinemas.com. However, the membership credits and benefits are managed through the CMX Mobile App. 3</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-plus-heading-2">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-plus-collapse-2"
                          aria-expanded="false"
                          aria-controls="movieflex-plus-collapse-2"
                        >
                          Can I sign up for multiple membership accounts?
                        </button>
                      </h2>
                      <div id="movieflex-plus-collapse-2" className="accordion-collapse collapse" aria-labelledby="movieflex-plus-heading-2" data-bs-parent="#movieflexplus-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>Only one Passport membership can be on one CMX Rewards account. The same billing address may be used for multiple accounts.</p>
                          </section>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="movieflex-plus-heading-3">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#movieflex-plus-collapse-3"
                          aria-expanded="false"
                          aria-controls="movieflex-plus-collapse-3"
                        >
                          Is there an age requirement to become a Passport member?
                        </button>
                      </h2>
                      <div id="movieflex-plus-collapse-3" className="accordion-collapse collapse" aria-labelledby="movieflex-plus-heading-3" data-bs-parent="#movieflexplus-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p> Yes, all members must be at least 18 years of age.</p>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="tab-pane fade" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                  <div className="accordion" id="fnb-accordionParent">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="fnb-heading-1">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fnb-collapse-1" aria-expanded="false" aria-controls="fnb-collapse-1">
                          How do I get my food and beverage discount?
                        </button>
                      </h2>
                      <div id="fnb-collapse-1" className="accordion-collapse collapse" aria-labelledby="fnb-heading-1" data-bs-parent="#fnb-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>When making a food and beverage purchase, apply your CMX Rewards member number to the transaction. The discount will automatically be applied.</p>
                          </section>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="fnb-heading-2">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fnb-collapse-2" aria-expanded="false" aria-controls="fnb-collapse-2">
                          Can I combine my Passport discount with other Reward Vouchers?
                        </button>
                      </h2>
                      <div id="fnb-collapse-2" className="accordion-collapse collapse" aria-labelledby="fnb-heading-2" data-bs-parent="#fnb-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>No, the Passport discount cannot be combined with other offers.</p>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="tab-pane fade" id="purchaseredeem" role="tabpanel" aria-labelledby="purchase-redeem-tab">
                  <div className="accordion" id="billing-accordionParent">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="billing-heading-1">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#billing-collapse-1"
                          aria-expanded="false"
                          aria-controls="billing-collapse-1"
                        >
                          How do I pay for my subscription?
                        </button>
                      </h2>
                      <div id="billing-collapse-1" className="accordion-collapse collapse" aria-labelledby="billing-heading-1" data-bs-parent="#billing-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>
                              A Passport membership must be paid with a credit card. Monthly payments plus applicable tax will be automatic on a reoccurring basis. Gift Cards cannot be used to
                              purchase the program.
                            </p>
                          </section>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="billing-heading-2">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#billing-collapse-2"
                          aria-expanded="false"
                          aria-controls="billing-collapse-2"
                        >
                          Is the renewal of the CMX Passport Subscription membership automatic?
                        </button>
                      </h2>
                      <div id="billing-collapse-2" className="accordion-collapse collapse" aria-labelledby="billing-heading-2" data-bs-parent="#billing-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>Yes, it is. CMX will charge the credit card on record for the member price on the same calendar day as your first completed payment.</p>
                          </section>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="billing-heading-3">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#billing-collapse-3"
                          aria-expanded="false"
                          aria-controls="billing-collapse-3"
                        >
                          What is my billing date?
                        </button>
                      </h2>
                      <div id="billing-collapse-3" className="accordion-collapse collapse" aria-labelledby="billing-heading-3" data-bs-parent="#billing-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>The billing date is based on the day of the month you signed up for your membership.</p>
                          </section>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="billing-heading-4">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#billing-collapse-4"
                          aria-expanded="false"
                          aria-controls="billing-collapse-4"
                        >
                          Will CMX Cinemas notify users if the subscription fee has changed?
                        </button>
                      </h2>
                      <div id="billing-collapse-4" className="accordion-collapse collapse" aria-labelledby="billing-heading-4" data-bs-parent="#billing-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>
                              Yes, CMX will notify users if the terms and conditions of the program have changed. CMX Cinemas reserves the right to change the Passport fee and terms of the program at
                              any time.
                            </p>
                          </section>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="billing-heading-5">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#billing-collapse-5"
                          aria-expanded="false"
                          aria-controls="billing-collapse-5"
                        >
                          How do I cancel my Passport membership?
                        </button>
                      </h2>
                      <div id="billing-collapse-5" className="accordion-collapse collapse" aria-labelledby="billing-heading-5" data-bs-parent="#billing-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>While we would prefer to keep you as a Passport member, canceling is easy.</p>
                            <p>
                              For annual members, you may cancel your program at any time. However, no refund will be issued. Your Passport credits will remain available for up to one year. Benefits
                              will end on the last day of your billing cycle.
                            </p>
                            <p>
                              For monthly members, you have a fourth (4) month minimum agreement before you can cancel your membership. After four (4) months have passed, visit the CMX Mobile App. In
                              your Passport Dashboard, click More, then Cancel Membership. Benefits will end on the last day of your billing cycle.
                            </p>
                          </section>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="billing-heading-6">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#billing-collapse-6"
                          aria-expanded="false"
                          aria-controls="billing-collapse-6"
                        >
                          What happens if the credit card on file cannot be charged?
                        </button>
                      </h2>
                      <div id="billing-collapse-6" className="accordion-collapse collapse" aria-labelledby="billing-heading-6" data-bs-parent="#billing-accordionParent">
                        <div className="accordion-body">
                          <section className="sub-body">
                            <p>
                              If the credit card on file cannot be charged, CMX will notify you by email three times to change the payment method. If the credit card fails after the third email, it
                              will result in your Passport membership being canceled. You will receive an email notifying you of the cancellation, which will go into effect at the end of your billing
                              cycle.
                            </p>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </section>

            {/* <section className='content-fnb'>
            <div class="accordion" id="accordionExample">
              {
                this.props.state.faqjson.map((faqData, index) => {
                  return(
                    <div class="accordion-item" key={index}>
                      <h2 class="accordion-header" id={`heading${index}`}>
                        <button class={`accordion-button ${index == 0 ? '':'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${index}`} aria-expanded={`${index == 0 ? 'true':''}`} aria-controls={`collapse${index}`}>
                          {faqData.title}
                        </button>
                      </h2>
                      <div id={`collapse${index}`} class={`accordion-collapse collapse ${index == 0 ? 'show':''}`} aria-labelledby={`heading${index}`} data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          {
                            faqData.body.map((bodtData, bindex) => {
                              return(
                                <p>{bodtData.description1}</p>
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </section> */}
          </section>
        </section>
      </section>
    );
  }
}

export default Faq;
